<!-- eslint-disable vue/multi-word-component-names -->
<!-- Markup generated verbatim from the-dream-international.html (page "programs"). -->
<template>
<div class="page" data-page="programs">
  <section class="phero">
    <div class="corner" aria-hidden="true"><svg viewBox="96 123 492 460" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="The Dream International"><path class="lg-gold" d="M 107.8 282.2 L 103.7 356.6 L 251.6 354 L 126.9 467.6 L 183.5 521.5 L 346.2 362.6 L 410.2 360.6 L 412.2 291.1 Z M 107.8 282.2"/><path class="lg-navy" d="M 412.9 272.6 L 428.1 130.1 L 428.2 129.4 L 353 129 L 345.9 270 Z M 412.9 272.6"/><path class="lg-navy" d="M 325.5 269.5 L 228.9 149.2 L 175.3 198.7 L 247 267.5 Z M 325.5 269.5"/><path class="lg-navy" d="M 432.9 275.7 L 431.2 352.6 L 550.9 265.7 L 505.5 210.1 Z M 432.9 275.7"/><path class="lg-gold" d="M 573.9 355.5 L 269.3 365.1 L 276 574.5 L 348.3 567.5 L 337.3 456.6 L 457.2 552.2 L 501.5 504 L 398.1 422.9 L 580.2 425.9 Z M 573.9 355.5"/></svg></div>
    <div class="wrap">
      <span class="eyebrow"><span class="dot"></span>Programs</span>
      <h1>Interactive, one-to-one learning without borders.</h1>
      <p class="lede">Education equity means reaching students regardless of location, gender or religion. Every program pairs one student with one teacher, live and online.</p>
      <div class="always" aria-label="Every program is">
        <span>Volunteer taught</span><span>One-to-one</span><span>Live online</span><span>All levels welcome</span><span>8 to 10 weeks</span>
      </div>
    </div>
  </section>

  <section class="block">
    <div class="wrap">
      <article class="pdetail" id="sbs">
        <div class="visual v-sbs" aria-hidden="true"><span class="word">STEP BY STEP</span><div class="steps"><i></i><i></i><i></i><i></i><i></i></div></div>
        <div>
          <span class="eyebrow">SBS &middot; English</span>
          <h2>Step by Step</h2>
          <div class="prose">
            <p>SBS connects experienced professionals from many industries across the United States with students abroad, with a primary focus on Arabic-speaking communities. Over a carefully planned season, students build confidence and skill in reading, writing and speaking English.</p>
            <p>Beyond grammar, SBS is a cross-cultural friendship. Students practice real conversations about work, study and the future they want.</p>
          </div>
          <dl class="specs"><div><dt>Focus</dt><dd>Reading, writing, speaking</dd></div><div><dt>Teachers</dt><dd>US professionals</dd></div><div><dt>Length</dt><dd>8 to 10 weeks</dd></div></dl>
        </div>
      </article>

      <article class="pdetail" id="lbl">
        <div class="visual v-lbl" aria-hidden="true"><pre><span class="n">1</span><span class="k">=SUM</span>(B2:B12)
<span class="n">2</span><span class="k">def</span> my_future():
<span class="n">3</span>    <span class="k">return</span> learn(<span class="s">"developer"</span>)
<span class="n">4</span>  <span class="cursor"></span></pre></div>
        <div>
          <span class="eyebrow">LBL &middot; Computer Literacy</span>
          <h2>Line by Line</h2>
          <div class="prose">
            <p>LBL is our computer literacy program. Students start with the tools every workplace uses, Microsoft 365 apps such as Word, Excel, PowerPoint and Outlook, and go on to coding and cybersecurity when they are ready. Instructors come from universities and technology companies.</p>
            <p>Each course is tailored to the student, line by line, with practical guidance on how to turn new skills into work.</p>
          </div>
          <dl class="specs"><div><dt>Focus</dt><dd>Microsoft 365, coding, cybersecurity</dd></div><div><dt>Teachers</dt><dd>Tech professionals and faculty</dd></div><div><dt>Length</dt><dd>8 to 10 weeks</dd></div></dl>
        </div>
      </article>

      <article class="pdetail" id="hanbud">
        <div class="visual v-han" aria-hidden="true"><span class="kr" lang="ko">한벗</span><span class="eq">Han (Hangeul) + Bud (friend)</span></div>
        <div>
          <span class="eyebrow">Hanbud &middot; Korean</span>
          <h2>Hanbud</h2>
          <div class="prose">
            <p>The name joins Han, from Hangeul, the Korean alphabet, with Bud, from the Korean word for friend. Interest in Korean music, film and culture has spread to every age group around the world, and Hanbud answers it.</p>
            <p>Proficient Korean-speaking teachers help students read, write and speak with confidence, whether they love Korean culture or hope to work in Korean-speaking industries.</p>
          </div>
          <dl class="specs"><div><dt>Focus</dt><dd>Korean language and culture</dd></div><div><dt>Teachers</dt><dd>Korean speakers</dd></div><div><dt>Length</dt><dd>8 to 10 weeks</dd></div></dl>
        </div>
      </article>
    </div>
  </section>
</div>
</template>

<script>
import { SITE } from '@/data/site';
import { openLogin } from '@/composables/useLogin';
import { copyText } from '@/composables/useToast';

export default {
  name: 'ProgramsPage',
  methods: {
    openLogin,
    openPaypal() {
      window.open(SITE.paypalDonateUrl, '_blank', 'noopener');
    },
    copy(key) {
      copyText(SITE.copyValues[key], this.$el.querySelector('#' + key));
    },
  },
};
</script>
